import React from 'react';
export function HeroSection() {
  return <div className="bg-[#002d4d] py-16 px-4" data-id="element-3740">
      <div className="max-w-4xl mx-auto text-center" data-id="element-3741">
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white tracking-tight" data-id="element-3742">
          How to Sell USED EDM Machines
        </h1>
      </div>
    </div>;
}